export const Container = {
  baseStyle: {
    px: '0',
    maxWidth: '64rem',
  },
};
